import React, { useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Post, PaginationState } from '../../contexts/PostContext';
import Pagination from '../../components/Pagination';
import moment from 'moment';
// 스타일드 컴포넌트
const PostsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

// 모바일 카드 형태 스타일 컴포넌트
const MobilePostList = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 15px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    display: flex;
  }
`;

const MobilePostCard = styled.div`
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f8f8f8;
  }
  
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    bottom: 0;
    background-color: #4a90e2;
    opacity: 0;
    transition: opacity 0.2s;
  }
  
  &:hover::after {
    opacity: 1;
  }
`;

const MobilePostTitle = styled(Link)`
  display: inline-block;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 10px;
  word-break: keep-all;
  overflow-wrap: break-word;
  padding-right: 5px;
  transition: color 0.2s;
  
  &:hover {
    color: #4a90e2;
  }
`;

const MobilePostMeta = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-top: 8px;
`;

const MobilePostMetaLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MobilePostMetaRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const MobileBadgeContainer = styled.div`
  display: inline-flex;
  gap: 5px;
  margin-top: 5px;
  flex-wrap: wrap;
`;

const MobileAuthor = styled.span`
  font-weight: 500;
  color: #333;
  background-color: #f0f0f0;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
`;

const MobileDate = styled.span`
  color: #888;
`;

const MobileViewCount = styled.span`
  display: flex;
  align-items: center;
  color: #888;
  
  &::before {
    content: "👁️";
    margin-right: 3px;
    font-size: 14px;
  }
`;

const TableHead = styled.thead`
  border-top: 2px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
`;

const TableBody = styled.tbody``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: center;
  font-weight: normal;
  color: #333;
  font-size: 14px;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #e0e0e0;

  &:hover {
    background-color: #f8f8f8;
  }
`;

const TableCell = styled.td`
  padding: 8px 10px;
  color: #333;
  vertical-align: middle;
`;

const PostTitle = styled(Link)`
  color: #333;
  text-decoration: none;
  display: flex;
  align-items: center;

  font-size: 14px;
  
  &:hover {
    opacity: 0.8;
  }
`;

const CommentCount = styled.span`
  color: #ff6b6b;
  margin-left: 5px;
  
  @media (max-width: 768px) {
    background-color: #ffd0d0;
    color: black;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    display: flex;
    align-items: center;
    
    &::before {
      content: "💬";
      margin-right: 3px;
    }
  }
`;

const NewBadge = styled.span`
  background-color: #51cf66;
  color: white;
  padding: 1px 4px;
  border-radius: 2px;
  font-size: 11px;
  margin-left: 5px;
  display: inline-block;
  
  @media (max-width: 768px) {
    padding: 2px 8px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    
    &::before {
      content: "✨";
      margin-right: 3px;
    }
  }
`;

const PopularBadge = styled.span`
  background-color: #ff6b6b;
  color: white;
  padding: 1px 4px;
  border-radius: 2px;
  font-size: 11px;
  margin-left: 5px;
  display: inline-block;
  
  @media (max-width: 768px) {
    background: linear-gradient(45deg, #ffbaba, #ff8787);
    padding: 2px 8px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    
    &::before {
      content: "🔥";
      margin-right: 3px;
    }
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 30px;
  color: #666;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin: 20px 0;
  
  @media (max-width: 768px) {
    padding: 20px 10px;
    margin: 15px 0;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 30px;
  color: #666;
  
  @media (max-width: 768px) {
    padding: 20px 10px;
  }
`;

const AuthorCell = styled.td`
  padding: 8px 10px;
  color: #333;
  text-align: center;
  font-size: 13px;
  position: relative;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 8px;
    max-width: 80px;
    
    &::after {
      display: none;
    }
  }
`;

const DateCell = styled.td`
  padding: 8px 10px;
  color: #666;
  font-size: 13px;
  text-align: center;
`;

const ViewCountCell = styled.td`
  padding: 8px 10px;
  color: #333;
  text-align: center;
  font-size: 13px;
`;

const IdCell = styled.td`
  padding: 8px 10px;
  color: #666;
  text-align: center;
  font-size: 12px;
`;

const BoardTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
  
  @media (max-width: 768px) {
    padding: 10px;
    margin-bottom: 12px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`;

const TotalCount = styled.div`
  font-size: 14px;
  color: #666;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const SortOptions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  
  @media (max-width: 768px) {
    padding: 8px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const SearchForm = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const SearchSelect = styled.select`
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  height: 36px;
  background-color: white;
  color: #444;
  min-width: 80px;
  
  &:focus {
    border-color: #4a90e2;
    outline: none;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: 40px;
  }
`;

const SearchInput = styled.input`
  padding: 5px 10px;
  border: 1px solid #ddd;
  font-size: 13px;
  margin: 0 8px;
  height: 36px;
  border-radius: 4px;
  flex: 1;
  max-width: 350px;
  
  &:focus {
    border-color: #4a90e2;
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    height: 40px;
    max-width: none;
  }
`;

const SearchButton = styled.button`
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 0 15px;
  font-size: 13px;
  cursor: pointer;
  height: 36px;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #3a7bc8;
  }
  
  &:active {
    background-color: #2c6cb0;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: 40px;
  }
`;

const WriteButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const WriteButton = styled(Link)`
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #3a7bc8;
  }
  
  &:active {
    background-color: #2c6cb0;
  }
  
  @media (max-width: 768px) {
    /* width: 100%; */
    justify-content: center;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    background: linear-gradient(45deg, #4a90e2, #5ca1e5);
    /* box-shadow: 0 2px 4px rgba(74, 144, 226, 0.3); */
  }
`;

interface PostListProps {
  boardId?: number;
  title?: string;
  showHeader?: boolean;
  customPageHandler?: (page: number) => void;
  list: Post[];
  pagination: PaginationState;
  loading?: boolean;
  canWrite?: boolean;
  showSearch?: boolean;
  searchHandler?: (searchType: string, searchQuery: string) => void;
  showWriteButton?: boolean;
}

const PostList: React.FC<PostListProps> = ({ 
  boardId, 
  title = '게시글',
  showHeader = true,
  customPageHandler,
  list,
  pagination,
  loading = false,
  canWrite = false,
  showSearch = false,
  searchHandler,
  showWriteButton = false
}) => {
  const [searchType, setSearchType] = useState('1');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  // 현재 날짜 기준으로 24시간 이내인지 확인하는 함수
  const isNew = useCallback((createdAt: string) => {
    const now = new Date();
    const created = new Date(createdAt);
    const diffTime = Math.abs(now.getTime() - created.getTime());
    const diffHours = diffTime / (1000 * 60 * 60);
    return diffHours <= 24;
  }, []);

  // 페이지 변경 핸들러
  const handlePageChange = useCallback((page: number) => {
    customPageHandler && customPageHandler(page);
  }, [customPageHandler]);

  // 검색 핸들러
  const handleSearch = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (searchHandler) {
      searchHandler(searchType, searchQuery);
    }
  }, [searchHandler, searchType, searchQuery]);

  if (loading && list.length === 0) {
    return <LoadingMessage>데이터를 불러오는 중입니다...</LoadingMessage>;
  }

  return (
    <>
      {showHeader && (
        <BoardTitleHeader>
          <TotalCount>{title} (전체 {pagination.totalItems || 0}) {pagination.currentPage && `/ ${pagination.currentPage} 페이지`}</TotalCount>
          <SortOptions></SortOptions>
        </BoardTitleHeader>
      )}

      {!loading && list.length > 0 ? (
        <>
          {/* PC 화면용 테이블 형태 */}
          <PostsTable>
            <TableHead>
              <tr>
                <TableHeaderCell style={{ width: '7%' }}>번호</TableHeaderCell>
                <TableHeaderCell style={{ width: '58%' }}>제목</TableHeaderCell>
                <TableHeaderCell style={{ width: '13%' }}>이름</TableHeaderCell>
                <TableHeaderCell style={{ width: '15%' }}>날짜</TableHeaderCell>
                <TableHeaderCell style={{ width: '7%' }}>조회</TableHeaderCell>
              </tr>
            </TableHead>
            <TableBody>
              {list.map((post) => (
                <TableRow key={post.post_id}>
                  <IdCell>{post.post_id}</IdCell>
                  <TableCell>
                    <PostTitle to={`/posts/${post.post_id}`}>
                      {post.title}
                      
                      {(post.commentCount && Number(post.commentCount) > 0) ? (
                        <CommentCount>[{post.commentCount}]</CommentCount>
                      ) : null}

                      {isNew(post.createdAt) && <NewBadge>NEW</NewBadge>}
                      {post.isPopular && <PopularBadge>HOT</PopularBadge>}
                    </PostTitle>
                  </TableCell>
                  <AuthorCell>{post.author.username}</AuthorCell>
                  <DateCell>
                    {/*new Date(post.createdAt).toLocaleDateString('ko-KR', {
                      year: undefined,
                      month: '2-digit',
                      day: '2-digit',
                    }).replace(/\./g, '')*/}
                    {moment(post.createdAt).format('MM.DD HH:mm')}
                  </DateCell>
                  <ViewCountCell>{post.viewCount || 0}</ViewCountCell>
                </TableRow>
              ))}
            </TableBody>
          </PostsTable>

          {/* 모바일 화면용 카드 형태 */}
          <MobilePostList>
            {list.map((post) => (
              <MobilePostCard key={post.post_id}>
                <MobilePostTitle to={`/posts/${post.post_id}`}>
                  {post.title}
                </MobilePostTitle>
                
                <MobileBadgeContainer>
                  {(post.commentCount && Number(post.commentCount) > 0) ? (
                    <CommentCount>댓글 {post.commentCount}</CommentCount>
                  ) : null}
                  {isNew(post.createdAt) && <NewBadge>NEW</NewBadge>}
                  {post.isPopular && <PopularBadge>HOT</PopularBadge>}
                </MobileBadgeContainer>
                
                <MobilePostMeta>
                  <MobilePostMetaLeft>
                    <MobileAuthor>{post.author.username}</MobileAuthor>
                  </MobilePostMetaLeft>
                  <MobilePostMetaRight>
                    <MobileDate>
                      {new Date(post.createdAt).toLocaleDateString('ko-KR', {
                        year: undefined,
                        month: '2-digit',
                        day: '2-digit',
                      }).replace(/\./g, '')}
                    </MobileDate>
                    <MobileViewCount>{post.viewCount || 0}</MobileViewCount>
                  </MobilePostMetaRight>
                </MobilePostMeta>
              </MobilePostCard>
            ))}
          </MobilePostList>

          <PaginationContainer>
            <Pagination
              currentPage={pagination.currentPage || 1}
              totalPages={pagination.totalPages || 1}
              onPageChange={handlePageChange}
            />
          </PaginationContainer>
        </>
      ) : (
        !loading && (
          <EmptyMessage>
            게시글이 없습니다.
          </EmptyMessage>
        )
      )}

      {showWriteButton && canWrite && boardId && (
        <WriteButtonContainer>
          <WriteButton to={`/posts/create?boardId=${boardId}`}>
            글쓰기
          </WriteButton>
        </WriteButtonContainer>
      )}

      {showSearch && searchHandler && (
        <SearchContainer>
          <SearchForm onSubmit={handleSearch}>
            <SearchSelect
              value={searchType}
              onChange={(e) => setSearchType(e.target.value)}
            >
              <option value="1">제목</option>
              <option value="2">내용</option>
              <option value="3">이름</option>
            </SearchSelect>
            <SearchInput
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="검색어를 입력하세요"
            />
            <SearchButton type="submit">검색</SearchButton>
          </SearchForm>
        </SearchContainer>
      )}
    </>
  );
};

export default PostList; 